import * as react_components from "../reactcomponent.js"
import * as utility from "../services.js"
import * as propertyTypes from "../property_types.js"
import React from "react";

interface DropDownListProps {
    uid: any;
    values: any;
    queryParameter: any;
    onTextChange(propertyName, value): any;
    context: utility.IContextProps;
    rootPropertyPath: any;
    extendedUid: string;
    metadataSettings: SelectState;
    settings: any;
    data: any;
    value: any;
    name: any;
}

export class KendoDropDownList extends React.Component<DropDownListProps, any>{
    private dropDownList;
    constructor(props) {
        super(props);
        this.state = { page: 0, isLoading: false }
    }

    getData = () => {
        var that = this;
        if (this.props.settings.dataUrl) {
            this.setState({ isLoading: true });
            utility.httpService.get(this.props.settings.dataUrl, {}, function (data) {
                that.setState({ values: data, isLoading: false });
            });
        }
    }

    componentDidMount() {
        var that = this;
        var $rootNode = $(this.refs.dropDownList);

        var list = $rootNode.kendoDropDownList({
            optionLabel: " ",
            dataTextField: this.props.settings.valueField,
            dataValueField: this.props.settings.keyField,
            change: function () {
                var value = this.value();
                that.props.onTextChange(that.props.settings.name, value);
            }
        });
        this.dropDownList = list.data("kendoDropDownList");
        this.getData();
    }

    componentDidUpdate(prevProps, prevState) {
        var value = this.props.values[this.props.settings.name];

        if (this.state.values !== prevState.values) {
            this.dropDownList.dataSource.data(this.state.values);
        }

        if (Array.isArray(value)) {
            this.dropDownList.value(value.slice());
        }
        else {
            this.dropDownList.value(value);
        }

        if (this.props.settings.dataUrl !== prevProps.settings.dataUrl || this.props.data !== prevProps.data) {
            this.getData();
        }
    }

    render() {
        var style = { width: "100%" };
        let spinner = null;
        if (this.state.isLoading) {
            spinner = <img src={this.props.context.variables["INNO_BASE_PATH"] + "Statistics/Content/img/spinner.gif"} />
        }
        return (<react_components.ReactColumn width={this.props.metadataSettings.width}>
            <div className="form-group">
                <react_components.TruncatedLabel>{this.props.settings.label}</react_components.TruncatedLabel>{spinner}
                <div>
                    <input ref="dropDownList" name={this.props.name} style={style} value={this.props.value}></input>
                </div>
            </div>
        </react_components.ReactColumn>)
    }
};

export class SelectState extends propertyTypes.BaseComponentProps {
    private labelMetadata = new propertyTypes.TranslatableTextProperty("label", "Label");
    public label: string;

    private dataUrlMetadata = new propertyTypes.ServiceSelectorProperty("dataUrl", "Data url", false, propertyTypes.DataSourceType.sql)
    public dataUrl: string;

    private keyFieldMetadata = new propertyTypes.TextProperty("keyField", "Key");
    public keyField: string;

    private valueFieldMetadata = new propertyTypes.TextProperty("valueField", "Value");
    public valueField: string;

    private isMandatoryMetadata = new propertyTypes.CheckBoxProperty("isMandatory", "Is mandatory?");
    public isMandatory: string;

    private selectMetadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.getNameMetadata().SetMandatory(true);
        this.selectMetadataAll = baseMetaData.concat([this.labelMetadata, this.keyFieldMetadata, this.dataUrlMetadata, this.valueFieldMetadata, this.isMandatoryMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.selectMetadataAll;
    }
}